

import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import VideosComponent from '../../components/videos';
import HeaderTags from '../../common/headerTags/HeaderTags';
import {
    getYoutubePlaylistsIfNeeded, getYoutubeLatestVideoIfNeeded, getYoutubeVideoByTitleIfNeeded,
} from '../../components/videos/actions/videosActions';

const headerTags = {
    title: 'Vídeos - Cultura, entretenimento e música', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Assista aos melhores vídeos de música, cultura e entretenimento. Confira entrevistas e fique por dentro das novidades sobre o seu artista favorito.',
        keywords: 'vídeos youtube, vídeos de artistas, videoclipe, artistas, novidades, lançamentos, informação, inscreva-se no canal',
        'og:title': 'Vídeos - Cultura, entretenimento e música',
        'og:description': 'Assista aos melhores vídeos de música, cultura e entretenimento. Confira entrevistas e fique por dentro das novidades sobre o seu artista favorito.',
        'og:image': 'https://a1media.antena1.com.br/image/share/videos.png',
    },
};

const Videos = () => (
    <div className="pageWrapper">
        <HeaderTags
            title={headerTags.title}
            meta={headerTags.meta}
        />
        <VideosComponent />
    </div>
);

Videos.fetchData = async (store, match) => {
    // using async/await here to guarantee the order of execution
    // we need the playlists to be present before searching for a video by title to avoid unnecessary requests to our api / youtube api
    // Note: we are not catching any errors here, hope this will not break anything ;)
    await store.dispatch(getYoutubePlaylistsIfNeeded(15));

    const videoTitle = match && match.params && match.params.videoTitle;

    if (videoTitle) {
        await store.dispatch(getYoutubeVideoByTitleIfNeeded(videoTitle));
    } else {
        await store.dispatch(getYoutubeLatestVideoIfNeeded());
    }

    return Promise.resolve();
};


// @TODO remove, once we have refactored all Pages and removed withRouter from the AppComponent
Videos.propTypes = exact({
    /* eslint-disable react/no-unused-prop-types */
    // Injected through withRouter but not used
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    staticContext: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */
});

export default Videos;
